import { render } from "./FeatherXSvg.vue?vue&type=template&id=86759940"
const script = {}
script.render = render

export default script